export const sv = {
  'error.first_name': 'Förnamn',
  'error.last_name': 'Efternamn',
  'error.email': 'E-post',
  'error.phone': 'Telefon',
  'error.employee_number': 'Anställningsnummer',
  'error.card_credit_limit': 'Kreditgräns',
  'error.allpay_credit_limit': 'Allpay kreditgräns',
  'error.value.missing': 'värde saknas',
  'error.value.invalid_format': 'innehåller felaktigt format',
  'error.value.duplicate': 'profiler med samma e-postadress',
  'error.value.ignored_change': 'kommer inte att uppdateras',
  'error.required': 'Obligatoriskt',
  'error.invalid_email': 'Ogiltig e-postadress',

  'error.import.invalid_email': 'Ogiltig e-postadress',
  'error.import.address_or_stop_required':
    'Antingen adress eller busshållplats krävs',
  'error.import.school_address_required': 'Adress krävs',
  'error.import.nin_required': 'Personnummer krävs',
  'error.import.invalid_nin_format': 'Måste vara i formatet ÅÅÅÅMMDD-XXXX',
  'error.import.invalid_zipcode': 'Ogiltigt postnummer',
  'error.import.delivery_address_required': 'Leveransadress krävs',
  'error.import.student_in_another_school':
    'Elev är redan inlagd på en annan organisation',
  'error.import.student_in_another_school_collection':
    'Elev är redan inlagd i {collection} på en annan organisation',
  'error.import.student_pending_inactivation':
    'Eleven är schemalagd för inaktivering på en annan organisation men har inte inaktiverats ännu',
  'error.import.student_pending_inactivation_details':
    'Eleven är schemalagd för inaktivering i {collection} på en annan organisation från {date} men har inte inaktiverats ännu',

  'status.inactive': 'Inaktiv',
  'status.submitted': 'Inskickad',
  'status.approved': 'Godkänd',
  'status.rejected': 'Avslagen',

  'period.status.upcoming': 'Kommande',
  'period.status.active': 'Aktiv',
  'period.status.past': 'Avslutad',

  'tab.information': 'Information',
  'tab.travellers': 'Resenärer',
  'tab.admins': 'Administratörer',
  'tab.advanced': 'Avancerat',
  'tab.profile': 'Profil',
  'tab.tickets': 'Biljetter',
  'tab.ticket_settings': 'Biljettinställningar',
  'tab.payers': 'Fakturamottagare',
  'tab.students': 'Elevhantering',
  'tab.imports': 'Importer',
  'tab.periods': 'Perioder',
  'tab.list': 'Lista',
  'tab.organizations': 'Organisationer',
  'tab.applications': 'Ansökningar',
  'tab.information_pages': 'Informationssidor',
  'tab.configuration': 'Konfiguration',
  'tab.transactions': 'Transaktioner',
  'tab.files': 'Filer',
  'tab.travels': 'Elevresor',
  'tab.transportation': 'Skolskjuts',
  'tab.child-and-youth': 'Barn- & ungdomskort',
  'tab.invoicing': 'Fakturering',
  'tab.info': 'Info',

  // App metadata
  'app.title': 'AllTix',
  'app.description':
    'Kollektivtrafikbiljetter och reshantering för {tenantName}',

  // Page metadata
  'page.dashboard.title': 'Översikt',
  'page.dashboard.description':
    'Översikt över din kollektivtrafik och biljetter',
  newImport: 'Ny import',

  'page.travellers.title': 'Resenärer',
  'page.travellers.description': 'Hantera resenärer och deras profiler',
  'page.search.title': 'Sök',
  'page.search.description': 'Sök efter resenärer',
  'page.traveller.title': '{travellerName}',
  'page.traveller.description': 'Resenärsprofil för {travellerName}',
  'page.traveller.details.title': 'Resenärer',
  'page.traveller.details.description': 'Visa och hantera resenärsinformation',
  'page.traveller.changeBearerWarning':
    'När man byter bärare ändras vilken bärare som är Föredragen. Alla automatiskt utställda biljetter (t.ex. skolbiljetter) kommer automatiskt att hamna på den nya Föredragna bäraren framöver.',

  'page.administrators.title': 'Administratörer',
  'page.administrators.description': 'Hantera administratörer och behörigheter',
  'page.administrator.title': '{adminName}',
  'page.administrator.description': 'Administratörsprofil för {adminName}',
  'page.administrator.details.title': 'Administratörsdetaljer',
  'page.administrator.details.description':
    'Visa och hantera administratörsinformation',

  'page.departments.title': 'Avdelningar',
  'page.departments.description':
    'Hantera organisationsavdelningar och hierarkier',
  'page.department.title': '{departmentName}',
  'page.department.description': 'Avdelningsinformation för {departmentName}',
  'page.department.details.title': 'Avdelningsdetaljer',
  'page.department.details.description':
    'Visa och hantera avdelningsinformation',

  'page.tickets.title': 'Biljetter',
  'page.tickets.description': 'Köp och hantera kollektivtrafikbiljetter',

  'page.reports.title': 'Rapporter',
  'page.reports.description':
    'Analys och rapporter över resor och transaktioner',
  'page.reports.transactions.title': 'Transaktioner',
  'page.reports.transactions.description':
    'Transaktionsrapporter och analys av köp och betalningar',
  'page.reports.files.title': 'Filer',
  'page.reports.files.description':
    'Exporterade filer och rapportfiler för nedladdning',

  'page.settings.title': 'Inställningar',
  'page.settings.description': 'Systeminställningar och konfiguration',

  'page.profile.title': 'Min profil',
  'page.profile.description': 'Hantera din personliga profil och inställningar',

  'page.login.title': 'Logga in',
  'page.login.description': 'Logga in på ditt kollektivtrafikskonto',

  'page.register.title': 'Registrera',
  'page.register.description': 'Skapa ett nytt kollektivtrafikskonto',

  'page.privacy.title': 'Integritetspolicy',
  'page.privacy.description':
    'Information om hur vi hanterar dina personuppgifter',

  'page.terms.title': 'Användarvillkor',
  'page.terms.description': 'Villkor för användning av kollektivtrafiktjänsten',

  // New page metadata keys
  'page.organizations.title': 'Organisationer',
  'page.organizations.description':
    'Hantera organisationer och deras inställningar',
  'page.organizations.list.title': 'Organisationslista',
  'page.organizations.list.description': 'Visa och hantera alla organisationer',
  'page.organizations.applications.title': 'Organisationsansökningar',
  'page.organizations.applications.description':
    'Granska och godkänn organisationsansökningar',
  'page.periods.title': 'Perioder',
  'page.periods.description':
    'Hantera biljettperioder för organisationernas elevkategorier',
  'page.organization.details.title': 'Organisationsdetaljer',
  'page.organization.details.description':
    'Visa och hantera organisationsinformation',

  'page.students.title': 'Elever',
  'page.students.description': 'Hantera elever och deras transport',
  'page.students.list.search.placeholder':
    'Sök på namn, personnummer, skola eller kortnummer',
  'page.students.list.search.placeholder.childAndYouth':
    'Sök på namn, personnummer, vårdnadshavares e-post eller kortnummer',
  'page.students.transportation.title': 'Skolskjuts',
  'page.students.transportation.description': 'Hantera skolskjuts för elever',
  'page.students.transportation.list.title': 'Skolskjutslista',
  'page.students.transportation.list.description':
    'Visa alla elever med skolskjuts',
  'page.students.transportation.periods.title': 'Skolskjuts – Perioder',
  'page.students.transportation.periods.description':
    'Hantera biljettperioder för skolskjuts',
  'page.students.travels.title': 'Elevresor',
  'page.students.travels.description': 'Hantera elevresor för elever',
  'page.students.travels.list.title': 'Elevresorlista',
  'page.students.travels.list.description':
    'Visa alla elever som använder elevresor',
  'page.students.travels.periods.title': 'Elevresor – Perioder',
  'page.students.travels.periods.description':
    'Hantera biljettperioder för elevresor',
  'page.students.child-and-youth.title': 'Barn- & ungdomskort',
  'page.students.child-and-youth.description': 'Hantera barn- & ungdomskort',
  'page.students.child-and-youth.list.title': 'Barn- & ungdomskortlista',
  'page.students.child-and-youth.list.description':
    'Visa alla elever med barn- & ungdomskort',
  'page.students.child-and-youth.periods.title':
    'Barn- & ungdomskort – Perioder',
  'page.students.child-and-youth.periods.description':
    'Hantera biljettperioder för barn- & ungdomskort',
  'page.students.travels.info.title': 'Elevresor – Info',
  'page.students.travels.info.description':
    'Information om hur elevresor fungerar',
  'page.students.transportation.info.title': 'Skolskjuts – Info',
  'page.students.transportation.info.description':
    'Information om hur skolskjuts fungerar',
  'page.students.child-and-youth.info.title': 'Barn- & ungdomskort – Info',
  'page.students.child-and-youth.info.description':
    'Information om hur barn- & ungdomskort fungerar',
  'page.students.manualEditWarning':
    'Manuell redigering av personer i en elevkategori kommer bli överskrivet vid nästa import om inte samma ändringar finns i importfilen.',

  'page.tenantSettings.title': 'Organisationsinställningar',
  'page.tenantSettings.description':
    'Hantera organisationsomfattande inställningar och konfiguration',
  'page.tenantSettings.information.title': 'Informationsinställningar',
  'page.tenantSettings.information.description':
    'Hantera FAQ, villkor och supportinformation',
  'page.tenantSettings.configuration.title': 'Konfiguration',
  'page.tenantSettings.configuration.description':
    'Systemkonfiguration och tekniska inställningar',
  'page.tenantSettings.students.title': 'Elevinställningar',
  'page.tenantSettings.students.description': 'Inställningar för elevprogram',

  'page.user.title': 'Användarinställningar',
  'page.user.description':
    'Hantera dina personliga inställningar och preferenser',

  'page.buyTicket.title': 'Köp biljett',
  'page.buyTicket.description': 'Köp kollektivtrafikbiljetter',

  'page.faq.title': 'FAQ',
  'page.faq.description': 'Vanliga frågor och hjälp',

  'page.support.title': 'Support',
  'page.support.description': 'Få hjälp och supportinformation',

  'page.systemAdministrators.title': 'Systemadministratörer',
  'page.systemAdministrators.description':
    'Hantera systemadministratörer och deras åtkomst',
  'page.systemAdministrator.details.title': 'Systemadministratörsdetaljer',
  'page.systemAdministrator.details.description':
    'Visa och hantera systemadministratörsinformation',

  'page.payers.title': 'Fakturamottagare',
  'page.payers.description':
    'Hantera fakturamottagare och faktureringsinformation',

  'page.privacyPolicy.title': 'Integritetspolicy',
  'page.privacyPolicy.description':
    'Information om datahantering och integritet',

  'page.termsAndConditions.title': 'Villkor',
  'page.termsAndConditions.description': 'Villkor för användning av tjänsten',

  'page.accessibilityStatement.title': 'Tillgänglighetsredogörelse',
  'page.accessibilityStatement.description':
    'Information om webbplatsens tillgänglighet',

  'page.downtime.title': 'Planerat underhåll',
  'page.downtime.description':
    'Portalen är stängd måndagen den 26 oktober 2026 på grund av en planerad systemuppdatering',

  'page.operatingStatus.title': 'Driftstatus',
  'page.operatingStatus.description': 'Aktuell system- och servicestatus',

  'selectPortal.title': 'Välj portal',
  'selectPortal.description':
    'Välj den portal som motsvarar den region eller stad där din organisation är verksam och har åtkomst till tjänsten.',
  'page.home.noTenants.title': 'Inga portaler tillgängliga',
  'page.home.noTenants.description':
    'Inga organisationsportaler är för närvarande tillgängliga',

  'page.profiles.title': 'Välj profil',
  'page.profiles.description': 'Välj din organisationsprofil',
  'page.profiles.noProfiles.title': 'Inga profiler',
  'page.profiles.noProfiles.description':
    'Inga profiler är kopplade till ditt konto',

  'page.menu.title': 'Meny',
  'page.menu.description': 'Huvudnavigationsmeny',

  'page.selfService.login.title': 'Självservice',
  'page.selfService.login.description':
    'Hantera dina biljetter och reseinformation',

  'page.offerings.title': 'Specialerbjudanden',
  'page.offerings.description': 'Specialerbjudanden på biljetter och kampanjer',

  'page.travellers.import.title': 'Importera resenärer',
  'page.travellers.import.description': 'Importera resenärsdata från fil',

  'page.imports.title': 'Importer',
  'page.imports.description': 'Tidigare importer',
  'page.imports.details.title': 'Importdetaljer',
  'page.imports.details.description': 'Detaljer för import',

  'page.students.invoicing.title': 'Fakturering',
  'page.students.invoicing.description': 'Faktureringsuppgifter för elever',

  'import.state.added': 'Tillagd',
  'import.state.updated': 'Uppdaterad',
  'import.state.restored': 'Återställd',
  'import.state.removed': 'Borttagen',
  'import.state.skipped': 'Överhoppad',
  'import.state.failed': 'Misslyckad',
  'import.state.addedPlural': 'Tillagda',
  'import.state.updatedPlural': 'Uppdaterade',
  'import.state.updatedManuallyModified': 'Uppdaterad (manuellt ändrad)',
  'import.state.updatedManuallyModifiedPlural':
    'Uppdaterade (manuellt ändrade)',
  'import.state.restoredPlural': 'Återställda',
  'import.state.removedPlural': 'Borttagna',
  'import.state.skippedPlural': 'Överhoppade',
  'import.state.failedPlural': 'Misslyckade',
  'import.state.confirmed': 'Bekräftad',
  'import.state.confirmedPlural': 'Bekräftade',

  'import.manuallyModified.title': 'Manuellt ändrad',
  'import.manuallyModified.description':
    'Datan har blivit manuellt redigerad och kan komma att skrivas över vid import om inte samma ändring(ar) finns med i import-filen.',

  'import.guardianAddressInfo.requiredForGuardian1':
    'Notera att adress och/eller hållplats krävs för Vårdnadshavare 1. Vårdnadshavare 2 är valfri men adress och/eller hållplats krävs om Vårdnadshavare 2 ska användas.',
  'import.guardianAddressInfo.usedForTravelSearch':
    'Adress/hållplats för Vårdnadshavare 1 och 2 används för göra resesök för vart biljetten ska gälla.',
  'import.guardianAddressInfo.busStopOptional':
    'Hållplats anges enbart när närmaste hållplats från adressen inte ger ett bra resultat. Det externa systemet Etis hittar bara hållplatser inom 3 km från adressen, så ligger närmaste hållplats längre bort måste hållplats anges. När hållplats anges är det hållplatsnamnet i Etis som gäller.',
  'import.deliveryAddressInfo.cardDelivery':
    'Leveransadress anger vart resekortet ska skickas. Vanligtvis folkbokföringsadressen eller skolans adress.',

  'claim.state.scheduled.label': 'Schemalagd',
  'claim.state.scheduled.description':
    'Systemet har schemalagt resenären för bearbetning för perioden.',
  'claim.state.card-ordered.label': 'Väntar på kort',
  'claim.state.card-ordered.description':
    'Kortbeställning lagd hos leverantör. När kortet skapats läggs biljettbeställning.',
  'claim.state.awaiting-card-transfer.label': 'Väntar på kortöverföring',
  'claim.state.awaiting-card-transfer.description':
    'Automatisk kortöverföring från tidigare skola pågår. Biljetten köps när överföringen är klar.',
  'claim.consecutiveFailures':
    '{count, plural, one {# misslyckat försök} other {# misslyckade försök}}',
  'claim.consecutiveFailures.description':
    'Antal gånger systemet har försökt köpa biljetten utan att lyckas.',
  'claim.state.card-order-failed.label': 'Kortbeställning misslyckades',
  'claim.state.card-order-failed.description':
    'Leverantörens system tillät inte kortbeställningen.',
  'claim.state.purchase-ordered.label': 'Biljettbeställning lagd',
  'claim.state.purchase-ordered.description':
    'Biljettbeställning lagd hos leverantör, inväntar bekräftelse på att biljetten har köpts.',
  'claim.state.purchase-failed.label': 'Köp misslyckades',
  'claim.state.purchase-failed.description':
    'Leverantörens system tillät inte biljettbeställningen för denna resenären.',
  'claim.state.unresolvable-relational-ticket.label': 'Biljett ej hittad',
  'claim.state.unresolvable-relational-ticket.description':
    'Gick inte att hitta en giltig biljett för de addresser som angivits.',
  'claim.state.fulfilled.label': 'Biljett köpt',
  'claim.state.fulfilled.description':
    'Biljetten har köpts och delats ut till resenären.',
  'claim.state.unfulfillable.label': 'Ej lösbart fel',
  'claim.state.unfulfillable.description':
    'Något har gått fel som inte går att lösa automatiskt och/eller på normalt sätt. Kontakta support.',

  'formElement.noValue': 'Inget värde',
  'formElement.requiredFieldHint': '(obligatoriskt fält)',

  'ticketOffer.deliveryMethodQuestion': 'Hur vill du ha biljetten?',
  'ticketOffer.emailAddress': 'E-postadress',
  'ticketOffer.cardNumber': 'Kortnummer',
  'ticketOffer.confirmationEmail': 'E-post för bekräftelse',
  'ticketOffer.confirmationEmailOptional': 'E-post för bekräftelse (valfritt)',
  'ticketOffer.accountNotFound':
    'Kunde inte hitta ett konto. Kontrollera att du skrivit rätt email och att kontot är registrerat i appen.',
  'ticketOffer.cardNotFound': 'Kunde inte hitta kortet',
  'ticketOffer.placeOrder': 'Beställ',
  'ticketOffer.termsDeclaration':
    'Jag intygar att jag fyllt i korrekt information ovan samt förstår att erbjudandet enbart får lov att nyttjas av den valda mottagaren.',
  'ticketOffer.recipientNinLabel': 'Mottagarens personnummer (12 siffror)',
  'ticketOffer.error.ninFormat':
    'Personnummer måste anges som YYYYMMDDXXXX eller YYYYMMDD-XXXX',
  'ticketOffer.error.emailAppRequired':
    'En giltig e-post krävs för app-leverans',
  'ticketOffer.error.cardNumberLength': 'Kortnummer måste vara 16 tecken',
  'ticketOffer.error.invalidEmail': 'Ange en giltig e-postadress',
  'ticketOffer.error.emailRequiredForDelivery':
    'E-post krävs för denna leveransmetod',
  'ticketOffer.error.generic': 'Något gick fel',
  'ticketOffer.error.recipientTooOld':
    'Mottagaren måste vara 19 år eller yngre',
  'ticketOffer.error.recipientBirthYear':
    'Mottagaren måste vara född mellan {minYear} och {maxYear}',
  'ticketOffer.loginBankId': 'Logga in med BankID',

  'ticketOffer.granted.pickUpCard':
    'Gå till kundtjänst för att hämta ut nytt fysiskt resekort',
  'ticketOffer.granted.availableSummer':
    'Erbjudandet är nu tillgängligt och kan nyttjas under sommarlovet.',
  'ticketOffer.granted.useInApp':
    'Det nyttjas i appen på en enhet som har den angivna e-posten kopplad.',
  'ticketOffer.granted.useOnCard': 'Det nyttjas genom det valda kortet.',
  'ticketOffer.granted.title': 'Beställningen genomförd',
  'ticketOffer.granted.dateLabel': 'Datum',
  'ticketOffer.granted.orderIdLabel': 'BeställningsID',
  'ticketOffer.granted.ticketIdLabel': 'BiljettID',
  'ticketOffer.granted.closePage': 'Du kan nu stänga ner sidan.',
  'ticketOffer.granted.orderAgain': 'Gör en till beställning',
} as const;
